const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const withSetURL = require("../hoc/withSetURL");
const withVaultDispatch = require("../hoc/withVaultDispatch");

const SVGIcon = require("./SVGIcon");

const AssetsUtil = require("../util/AssetsUtil");
const Sounds = require("../util/Sounds");

const AT = require("../vault/ActionTypes");
const OpsBlock = require("../vault/OpsBlock");
const OpsPage = require("../vault/OpsPage");
const OpsUser = require("../vault/OpsUser");

const ChapterSection = require("../../../shared/ChapterSection");
const GradeChapter = require("../../../shared/GradeChapter");
const TrainerCore = require("../../../shared/TrainerCore");
const URLMake = require("../../../shared/URLMake");

const styles = require("./styles/SequenceRow.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withSetURL(Component);
	Component = withVaultDispatch(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "SequenceRow",

		propTypes: {
			// current page user is on
			user: PT.object.isRequired,
			type: PT.oneOf(["assignment", "playlist"]).isRequired,
			page: PT.object.isRequired,
			blockModel: PT.object.isRequired,
			clickHandler: PT.func.isRequired,
			index: PT.number,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			setURL: PT.func.isRequired,
		},

		isPageForBlock: function(type) {
			const {page} = this.props;
			const {
				gradeNumber,
				chapterIndex,
				blockIndex,
				blockID,
			} = this.props.blockModel;
			const chapterID = GradeChapter.toChapterID(gradeNumber, chapterIndex);
			const videoModalOpen = _.get(page, "showVideo");
			const bookModalOpen = _.get(page, "showBook");
			const isTrainerPage = OpsPage.isTrainerProblemPage(page);
			const isTheaterPage = OpsPage.isTheaterSetPage(page);
			const isLibraryPage = OpsPage.isLibraryChapterPage(page);

			const sameGradeChapter = pg =>
				gradeNumber === _.get(pg, "gradeNumber") &&
				chapterIndex === _.get(pg, "chapterIndex");

			const sameTrainerBlock = pg =>
				sameGradeChapter(pg) && blockIndex === _.get(pg, "blockIndex");

			if (type === "trainer" && isTrainerPage) {
				return sameTrainerBlock(page) && !(videoModalOpen || bookModalOpen);
			} else if (type === "theater") {
				if (isTheaterPage && !bookModalOpen) {
					// On actual theater page
					return sameGradeChapter(page) && blockID === _.get(page, "blockID");
				} else if (isTrainerPage && sameTrainerBlock(page) && videoModalOpen) {
					// On trainer problem page but video modal is open
					return true;
				}
			} else if (type === "library") {
				const blockPages = _.cloneDeep(_.get(this.props.blockModel, "pages"));
				const chapterPages = ChapterSection.getChapterPages(chapterID);
				if (blockPages[0] === chapterPages[0] + 2) {
					// we want to account for the first two intro pages
					// and consider them with the first section of the chapter
					blockPages[0] = chapterPages[0];
				}
				const p = _.get(page, "sequencePage");
				const eBookMatch =
					sameGradeChapter(page) &&
					(p || p === 0) &&
					p >= blockPages[0] &&
					p <= blockPages[1];
				if (isLibraryPage) {
					// On actual library book page
					return eBookMatch;
				} else if (
					(isTrainerPage || isTheaterPage) &&
					eBookMatch &&
					bookModalOpen
				) {
					// On trainer problem page or theater page but book modal is open
					return true;
				}
			}
			return false;
		},

		getPageState: function(type) {
			const {
				blockID,
				gradeNumber,
				chapterIndex,
				blockIndex,
				bookSectionIndex,
				pages,
			} = this.props.blockModel;
			let pageState;
			if (type === "trainer") {
				pageState = URLMake.state.forBlockFromNumbers(
					gradeNumber,
					chapterIndex,
					blockIndex
				);
			} else if (type === "library") {
				const page = _.get(pages, "[0]");
				pageState = URLMake.state.forLibraryFromNumbers(
					gradeNumber,
					chapterIndex,
					bookSectionIndex,
					page
				);
			} else if (type === "theater") {
				pageState = URLMake.state.forTheaterFromNumbers(
					gradeNumber,
					chapterIndex,
					blockID
				);
			}
			return pageState;
		},

		pageRedirect: function(pageState) {
			if (pageState) {
				/*
					This time-out is needed to allow the slider time for a smooth transition when closing,
					since the page reloading is so intensive and causes jerky close

					for a smooth transition with shortest lag between slider closing and
					page reloading, we use a value of 515 ms. This value is chosen ad hoc.
				*/
				setTimeout(
					() =>
						this.props.dispatch({
							type: AT.SET_PAGE,
							pageState,
							addToHistory: true,
						}),
					515
				);
			}
			// Take care of this.props.clickHandler since redirects occur on link clicks
			return this.props.clickHandler();
		},

		onIconClick: function(pageState) {
			const soundMap = {
				trainer: "lesson-click",
				test: "lesson-click",
				library: "book-section-click",
			};
			const {blockModel} = this.props;
			const {blockType} = blockModel;
			Sounds.playSound(soundMap[blockType]);
			return this.pageRedirect(pageState);
		},

		onTestClick: function() {
			this.props.dispatch({
				type: AT.GOTO_TEST,
				props: this.props,
			});
		},

		renderLockedMask() {
			return (
				<div className={styles.maskContainer}>
					<div className={styles.mask} />
					<img
						className={styles.lockImg}
						src={AssetsUtil.getButton("lock-tilted")}
					/>
				</div>
			);
		},

		makeHWIcon() {
			const {blockModel, type} = this.props;

			switch (type) {
				case "assignment":
					const {user} = this.props;
					const {
						isAcademy,
						isComplete,
						isCurrentWeek,
					} = OpsUser.getHomeworkDataForBlock(user, blockModel);
					const isOld = isAcademy && !isCurrentWeek;
					const className = isOld ? styles.leftIconOld : styles.leftIcon;
					return (
						<img
							className={className}
							src={AssetsUtil.getHWIcon(isAcademy, isComplete)}
						/>
					);

				case "playlist":
					const cs = {
						completed: "iconYellow",
						current: "white",
						default: "mediumLightGray",
					};
					const {blockType} = blockModel;
					const isCurrent = this.isPageForBlock(blockType);

					let fillToUse = cs.default;
					if (isCurrent) fillToUse = cs.current;
					else if (blockModel.isComplete) fillToUse = cs.completed;
					return (
						<SVGIcon
							type={blockType}
							useWonkyCursor={true}
							colorName={fillToUse}
							mainClass={styles.leftIcon}
						/>
					);
			}
		},

		makeVideoImgSVG(gradeNumber, isCurrentTrainer, isCurrentTheater) {
			return (
				<SVGIcon
					type={isCurrentTheater ? "theater-play-selected" : "theater-play"}
					useColorHoverEffect={!isCurrentTrainer}
					useWonkyCursor={true}
					disabled={isCurrentTheater}
					colorName={isCurrentTrainer ? "white" : `grade-${gradeNumber}`}
					mainClass={
						isCurrentTheater ? styles.videoIconImgPlaying : styles.videoIconImg
					}
					svgClass={isCurrentTrainer ? styles.videoHover : null}
				/>
			);
		},

		renderVideoIcon() {
			const {gradeNumber} = this.props.blockModel;
			const isCurrentPageTrainer = this.isPageForBlock("trainer");
			const isCurrentPageTheater = this.isPageForBlock("theater");
			const videoPageState = this.getPageState("theater");
			const videoIconImg = this.makeVideoImgSVG(
				gradeNumber,
				isCurrentPageTrainer,
				isCurrentPageTheater
			);

			let className = styles.videoIcon;
			if (!isCurrentPageTheater) {
				className += " " + styles.link;
			}

			return (
				<div
					className={className}
					onClick={() => this.onIconClick(videoPageState)}
				>
					{videoIconImg}
				</div>
			);
		},

		renderBonusIcon(gradeNumber, isCurrentTrainer) {
			return (
				<SVGIcon
					type={"bonus-beast"}
					useWonkyCursor={true}
					colorName={isCurrentTrainer ? "white" : `grade-${gradeNumber}`}
					mainClass={styles.bonusIcon}
				/>
			);
		},

		render: function() {
			const {
				gradeNumber,
				chapterIndex,
				displayName,
				trainerComplete,
				requirementLevel,
				blockType,
				unlocked,
			} = this.props.blockModel;
			const isTest = blockType === "test";
			const isCurrentPage = this.isPageForBlock(blockType);
			const isCurrentTheater = this.isPageForBlock("theater");
			const pageState = this.getPageState(blockType);
			const bgClassName = isCurrentPage
				? styles[`current-grade${gradeNumber}`]
				: styles.main;
			const isBonus = TrainerCore.isBonusBlock(requirementLevel);
			let titleTextClass = styles.rowTitleText;
			if (isCurrentTheater) {
				titleTextClass += " " + styles.videoPlaying;
			}
			if (!isBonus) {
				titleTextClass += " " + styles.nonBonusRowTitleText;
			}

			let className = styles[`row-grade${gradeNumber}`];
			if (isCurrentPage) {
				className += " " + styles.onPage;
			} else {
				className += " " + styles.link;
			}
			// users shouldn't be able to access tests if they have an assigned book test
			const forceAsLocked =
				isTest && OpsUser.bookTestAssignedNow(this.props.user);
			const locked = !unlocked || forceAsLocked;
			const lockMask = locked ? this.renderLockedMask() : null;
			const disabledStyle = locked ? styles.locked : null;

			const trainerIcon = this.makeHWIcon(
				"trainer",
				trainerComplete,
				isCurrentPage
			);
			const videoIcon = OpsBlock.hasVideoSetID(this.props.blockModel)
				? this.renderVideoIcon()
				: null;

			let innerContent;
			let handleClick;
			if (isTest) {
				handleClick = () => this.onTestClick();
				innerContent = (
					<div className={titleTextClass}>{`${gradeNumber}.${chapterIndex +
						1} Chapter Test`}</div>
				);
			} else {
				const title = <div className={titleTextClass}>{displayName}</div>;
				const bonusIcon = isBonus
					? this.renderBonusIcon(gradeNumber, isCurrentPage)
					: null;
				let trainerPageState = pageState;
				if (
					this.props.type === "assignment" &&
					blockType === "trainer" &&
					OpsUser.getHomeworkDataForBlock(
						this.props.user,
						this.props.blockModel
					).isComplete
				) {
					trainerPageState = _.extend({}, pageState, {
						problemIndex: "summary",
					});
				}
				handleClick = () => this.onIconClick(trainerPageState);
				innerContent = (
					<>
						{bonusIcon}
						{title}
					</>
				);
			}

			return (
				<div className={bgClassName + " " + disabledStyle}>
					<div onClick={handleClick} className={className}>
						{trainerIcon}
						<div className={styles.contentContainer}>{innerContent}</div>
					</div>
					{videoIcon}
					{lockMask}
					<div className={styles.partition} />
				</div>
			);
		},
	})
);
